import { LoadingImage } from "SuperAdmin/Components";
import { ConstantVariables } from "SuperAdmin/Config/ConstantVariables";
import {
  getAccountInformationById,
  updateAccountByID,
  updateAssignRole,
} from "SuperAdmin/Services/Account";
import { Form, message } from "antd";
import { addItem } from "Redux/Slices/BreadCrumb";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import styles from "./AccountDetail.module.scss";
import FormUpdate from "./Components/Form/Form";
import { useNavigate } from "react-router-dom";
import { handleAPIResponse } from "SuperAdmin/Utils/HandleAPIResponse";

const AccountDetail = () => {
  const account_id = window.location.pathname.split("/")[3];
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const name = Form.useWatch("name", form);
  const position = Form.useWatch("position", form);
  const profileUrl = Form.useWatch("profile_url", form);
  const mappedProfileID = Form.useWatch("mapped_profile_id", form);
  const activate = Form.useWatch("activate", form);
  const role = Form.useWatch("role", form);
  const [isLoading, setIsLoading] = useState(true);
  const [addedRole, setAddedRole] = useState(null);
  const [profileData, setProfileData] = useState(false);
  useEffect(() => {
    setIsLoading(true);
    getAccountInformationById(account_id, (res) => {
      if (res) {
        dispatch(
          addItem({
            key: account_id,
            label: res.data.name,
            to: `/accounts/${account_id}`,
            name: res.data.name,
            level: 2,
          })
        );
        handleAPIResponse(res, () => {
          form.setFieldsValue({
            mapped_profile_id: res.data.mapped_profile_id,
            name: res.data.name,
            email: res.data.email,
            institution: res.data.institution_name,
            department: res.data.departments,
            position: res.data.position,
            profile_url: res.data.profile_url,
            activate: res.data.activate ? 1 : 2,
            role: res.data.role,
            photo: res.data.photo_url,
          });
          setIsLoading(false);
          setProfileData(res.data);
        });
      }
    });
  }, [window.location.pathname]);
  const onFinishForm = () => {
    const payload = {
      activate: activate == 1 ? true : false,
      name: name,
      personal_page_url: profileUrl,
      mappedProfileID: mappedProfileID,
      position: position,
      role: role,
    };
    updateAccountByID(account_id, payload, (res) => {
      if (addedRole) {
        console.log(addedRole);
        updateAssignRole(account_id, addedRole.id, (response) => {
          if (response.detail) {
            message.error(response?.detail);
          }
        });
      }
      setTimeout(() => {
        message.success("Update user successfully !");
      }, 1500);
      navigate("/super-admin/accounts");
    });
  };
  return (
    <div className={styles["account-detail"]}>
      <div className={styles["image"]}>
        <LoadingImage
          isLoading={isLoading}
          component={
            <img
              src={
                form.getFieldValue().photo
                  ? form.getFieldValue().photo
                  : ConstantVariables.no_photo_faculty
              }
              alt="account_image"
            />
          }
        />
      </div>
      <FormUpdate
        isLoading={isLoading}
        form={form}
        role={role}
        activate={activate}
        onFinishForm={onFinishForm}
        setAddedRole={setAddedRole}
        profileData={profileData}
      />
    </div>
  );
};

export default AccountDetail;
